import { cn } from '@/lib/utils';

export default function StatusBadge({
  status = 'completed',
  className,
}: {
  status?: string;
  className?: string;
} = {}) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full px-[7px] py-1 text-sm text-white',
        {
          'bg-emerald-500/20': status === 'Completed',
          'bg-[#FF9D002E]': status === 'Scheduled',
          'bg-[#DC1D004D]': status === 'Canceled',
          'bg-[#c27c714d]': status === 'Open',
          'bg-[#ffb9af4d]': status === 'No-Show',
        },
        className,
      )}
    >
      <span
        className={cn('h-[14px] w-[14px] rounded-full', {
          'bg-[#5FD982]': status === 'Completed',
          'bg-[#E8801C]': status === 'Scheduled',
          'bg-[#FD0000]': status === 'Canceled',
          'bg-[#ffa3a3]': status === 'Open',
          'bg-[#d64c374d]': status === 'No-Show',
        })}
      />
      <span className='capitalize'>{status}</span>
    </div>
  );
}
